(function () {
  const IMAGE_PROPERTY_KEYS = [
    'Uploaded Image', 'Custom Image', 'File', 'Upload',
    'Image', 'upload_lift_file', 'Customer Image'
  ];

  const originalFetch = window.fetch;
  window.fetch = function (url, options) {
    if (typeof url === 'string' && options && options.body) {
      try {
        const body = JSON.parse(options.body);
        if (url.includes('/cart/add') && body.properties) {
          IMAGE_PROPERTY_KEYS.forEach((key) => {
            if (body.properties[key] !== undefined) {
              const val = body.properties[key];
              if (!val || !val.startsWith('http')) {
                delete body.properties[key];
              }
            }
          });
          options.body = JSON.stringify(body);
        }
      } catch (e) {}
    }
    return originalFetch.apply(this, arguments);
  };

  const originalOpen = XMLHttpRequest.prototype.open;
  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._url = url;
    return originalOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    if (this._url && this._url.includes('/cart/add') && body) {
      try {
        const parsed = JSON.parse(body);
        if (parsed.properties) {
          IMAGE_PROPERTY_KEYS.forEach((key) => {
            if (parsed.properties[key] !== undefined) {
              const val = parsed.properties[key];
              if (!val || !val.startsWith('http')) {
                delete parsed.properties[key];
              }
            }
          });
          body = JSON.stringify(parsed);
        }
      } catch (e) {}
    }
    return originalSend.call(this, body);
  };
})();
